// 项目任命书
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行-委托单位and评价类型 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
          <span>委托单位</span>
        </div>
        <div class="rightInput">
          <span
            :title="S_company_name"
            class="isNotSubmitSpan"
            style="display:block;min-width:220px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
          >{{S_company_name}}</span>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_pp2@2x.png" alt />
          <span>评价类型</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_pte_name}}</span>
        </div>
      </div>
    </div>
    <!-- 第三行--企业地址 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_dzhi@2x.png" alt />
        <span>企业地址</span>
      </div>
      <div class="rightInput">
        <el-input
          :disabled="!isSubmit"
          :placeholder="isSubmit ? '请输入企业地址' : ''"
          v-model="addFormData.enterprise_address"
        ></el-input>
      </div>
    </div>
    <!-- 第三行--外部项目编号 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_dzhi@2x.png" alt />
        <span>外部项目编号</span>
      </div>
      <div class="rightInput">
        <el-input
          :disabled="!isSubmit"
          :placeholder="isSubmit ? '选填' : ''"
          v-model="addFormData.item_code"
        ></el-input>
      </div>
    </div>
    <!-- 第四行--电话/传真and企业联系人 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:14px" src="../../assets/image/icon_lxr@2x.png" alt />
          <span>企业联系人</span>
        </div>
        <div class="rightInput">
          <el-input
            :disabled="!isSubmit"
            :placeholder="isSubmit ? '输入姓名' : ''"
            v-model="addFormData.enterprise_contacts"
          ></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:13px" src="../../assets/image/icon_sjzh@2x.png" alt />
          <span>电话/传真</span>
        </div>
        <div class="rightInput">
          <el-input
            :disabled="!isSubmit"
            :placeholder="isSubmit ? '输入电话' : ''"
            v-model="addFormData.enterprise_contact"
          ></el-input>
        </div>
      </div>
    </div>
    <!-- 第五行--计划开始日期and计划结束日期 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>计划开始日期</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            value-format="yyyy-MM-dd"
            v-model="addFormData.start_date"
            type="date"
            :picker-options="pickerOptionsStart"
            :placeholder="isSubmit ? '选择日期' : ''"
          ></el-date-picker>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>计划结束日期</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            value-format="yyyy-MM-dd"
            v-model="addFormData.end_date"
            :picker-options="pickerOptionsEnd"
            type="date"
            :placeholder="isSubmit ? '选择日期' : ''"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <!-- 第六行--评价组成员 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zy@2x.png" alt />
        <span>评价组成员</span>
      </div>
      <div class="rightInput">
        <el-button class="AddUser" v-if="isSubmit" @click="handleAddTM">添加成员</el-button>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:35px;padding-left:30px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="nickname"
          label="姓名"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.nickname}}</span>
            <span v-else>{{scope.row.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="number"
          label="资质证书编号"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.number}}</span>
            <span v-else>{{scope.row.number}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="major" label="人员专业">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.major}}</span>
            <span v-else>{{scope.row.major}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="work" label="承担工作">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.work}}</span>
            <span v-else>{{scope.row.work}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <span
              v-if="isSubmit"
              @click="removeUser(scope.$index,scope.row)"
              style="cursor: pointer;color:#128BF1"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 上传 -->
    <div class="oneRow" type="min-height:60px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <!-- 上传 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传项目组任命书,模板文件：</div>
        <a
          style="font-size:14px;"
          href="http://control.sxpz.vip/Template/安全评价项目组任命书.doc"
        >安全评价项目组任命书.doc</a>
      </div>
    </div>
    <!-- 第七行-任务内容及要求 -->
    <div class="oneRow">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_renw@2x.png" alt />
        <span>任务内容及要求</span>
      </div>
    </div>
    <ul class="workNeed">
      <li>1.负责与企业对接，沟通报告相关事宜；</li>
      <li>2.按照要求完成报告的编制和修订工作；</li>
      <li>3.负责现场勘查，记录现场勘查内容；</li>
      <li>4.客观、公正、严谨的编制报告；</li>
      <li>5.到达企业后，注意自身安全，佩戴劳动防护用品，按照企业规章制度开展工作。</li>
    </ul>
    <p
      v-if="addFormData.evaluators"
      v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据本机构工作计划安排，特任命以下人员为评价组成员，任命'+ addFormData.evaluators.nickname +'担任本次评价组长，要求在规定时间内完成本项目的安全评价工作。'"
      style="color:#333;font-size:16px;width:74%;padding-left:20px;min-width: 650px;margin-bottom:20px"
    ></p>
    <p
      v-else
      v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据本机构工作计划安排，特任命以下人员为评价组成员，任命_____担任本次评价组长，要求在规定时间内完成本项目的安全评价工作。'"
      style="color:#333;font-size:16px;width:74%;padding-left:20px;min-width: 650px;margin-bottom:20px"
    ></p>
    <!-- 第八行 -->
    <!-- 签字 -->
    <!-- <div class="writeName">
      <span>总经理（签发）：</span>
      <img
        v-if="!addFormData.sign_manager"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_manager"
        @click="handleReceiverFlag1(addFormData.sign_manager)"
        style="width:66px;"
        :src="addFormData.sign_manager"
        alt
      />
    </div>-->
    <!-- <div class="writeName" style="margin-bottom:30px">
      <span>项目组长（签字）：</span>
      <img
        v-if="!addFormData.sign_leader"
        @click="handleReceiverFlag2"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_leader"
        @click="handleReceiverFlag2(addFormData.sign_leader)"
        style="width:66px;"
        :src="addFormData.sign_leader"
        alt
      />
    </div>-->
    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>
    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone2"
      :visible.sync="receiverSignFlag2"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 项目评价书-评价组成员添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加成员</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="姓名">
            <el-input :placeholder="isSubmit ? '请输入姓名' : ''" v-model="AddUserForm.nickname"></el-input>
          </el-form-item>
          <el-form-item label="资质证书编号">
            <el-input :placeholder="isSubmit ? '请输入资质证书编号' : ''" v-model="AddUserForm.number"></el-input>
          </el-form-item>
          <el-form-item label="人员专业">
            <el-input :placeholder="isSubmit ? '请输入人员专业' : ''" v-model="AddUserForm.major"></el-input>
          </el-form-item>
          <el-form-item label="承担工作">
            <el-input :placeholder="isSubmit ? '请输入承担工作' : ''" v-model="AddUserForm.work"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="editUserForm">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'14'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SignDialog from '../SignDialog'
import GoFinance from '../GoFinance'
import ProjectFlow from '../ProjectFlow'
import UploadFile from '../UploadFile'

export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      detailsImgList: [],
      submitImgList: [],
      diaFormType: 'add',
      editTableIndex: '',

      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      S_company_name: '',
      S_pte_name: '',

      approval_remark: '',
      isSubmit: true,
      selectIds: [],
      infop: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      projectTypeList: [],
      projectPjList: [],
      addFormData: {
        annex: '',
        enterprise_address: '',
        enterprise_contacts: '',
        enterprise_contact: '',
        start_date: '',
        item_code: '',
        end_date: '',
        member_json: '',
        sign_manager: '',
        // sign_leader: '',
      },
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      dialogVisibleAdd: false,
      AddUserForm: {
        nickname: '',
        number: '',
        major: '',
        work: '',
      },
      infop: '',
      member_id: '',
      token: '',
      value: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕',
        },
      ],
      tableData: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.addFormData.end_date) {
            return (
              time.getTime() > new Date(this.addFormData.end_date).getTime()
            )
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.addFormData.start_date) {
            return (
              time.getTime() < new Date(this.addFormData.start_date).getTime()
            )
          }
        },
      },
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
          param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      // 提交修改的那个
      console.log('提交修改this.AddUserForm', this.AddUserForm)
      this.dialogVisibleAdd = false
    },
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      console.log('this.AddUserForm', this.AddUserForm)
      console.log('点击了哪一行', this.AddUserForm)
      this.dialogVisibleAdd = true
    },
    // 添加成员
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        nickname: this.AddUserForm.nickname,
        number: this.AddUserForm.number,
        major: this.AddUserForm.major,
        work: this.AddUserForm.work,
      })
      this.dialogVisibleAdd = false
    },
    // 删除成员
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
          param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/appointment_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.member_json = JSON.stringify(this.tableData)

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
          param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        param.append('annex', JSON.stringify(this.submitImgList))
        param.append('enterprise_address', this.addFormData.enterprise_address)
        param.append('item_code', this.addFormData.item_code)
        param.append(
          'enterprise_contacts',
          this.addFormData.enterprise_contacts
        )
        param.append('enterprise_contact', this.addFormData.enterprise_contact)
        param.append('start_date', this.addFormData.start_date)
        param.append('end_date', this.addFormData.end_date)
        param.append('member_json', this.addFormData.member_json)
        // param.append('sign_manager', this.addFormData.sign_manager)
        // param.append('sign_leader', this.addFormData.sign_leader)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/appointment',
          data: param,
        })
        if (res.code != 200) {
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取项目详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
        param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/appointment_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是第一次填写
      if (res.datas.info.is_new != '1') {
        this.addFormData = res.datas.info
      }
      // 如果有项目名称
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      this.S_project_name = res.datas.info.project_name
      this.S_company_name = res.datas.info.company_name
      this.S_pte_name = res.datas.info.pte_name
      // 命名评价名称
      this.projectPjList.forEach((item) => {
        if (item.pte_id == this.S_pte_name) {
          return (this.S_pte_name = item.pte_name)
        }
      })
      if (this.addFormData.member_json) {
        this.tableData = this.addFormData.member_json
      }
      // 判断签名
      if (this.addFormData.sign_manager == 'undefined') {
        this.addFormData.sign_manager = ''
      }
      // 判断外部项目编号
      if (
        this.addFormData.item_code == 'undefined' ||
        this.addFormData.item_code == 'null' ||
        this.addFormData.item_code == null
      ) {
        this.addFormData.item_code = ''
      }
      // 处理文件
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // if (this.addFormData.sign_leader == 'undefined') {
      //   this.addFormData.sign_leader = ''
      // }
      // 处理时间
      if (this.addFormData.start_date == '0') {
        this.addFormData.start_date = ''
      }
      if (this.addFormData.end_date == '0') {
        this.addFormData.end_date = ''
      }
      this.isComponentsShow = true
      console.log('项目任命书-详情', this.addFormData)
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_manager = data
    },
    handleWriteDone2(data) {
      this.addFormData.sign_leader = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverFlag2(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag2 = true
    },
    handleReceiverSign() {},

    // 签名
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
        param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
        param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
    // 获取评价类型
    async getPjTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
        param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/evaluation_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectPjList = res.datas.listInfo
      console.log('评价类型列表', this.projectPjList)
      if (this.details_project_status && this.details_project_id) {
        this.getProjectDetails()
      }
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = {
        nickname: '',
        number: '',
        major: '',
        work: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProjectTypeList()
    this.getPjTypeList()
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
  },
  components: {
    SignDialog,
    ProjectFlow,
    UploadFile,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(./projectForm.less);
</style>